"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLibMsg = exports.useSignDirectForMetamask = exports.TxGasCostTypeMap = exports.TxMinGasPriceTypeDefaultKey = exports.TxGasCostTypeDefaultKey = exports.DEFAULT_SIGN_OPTS = exports.Types = exports.CarbonCustomError = exports.ErrorType = exports.BroadcastTxMode = exports.getSender = exports.decode = void 0;
const codec_1 = require("../codec");
const CosmosModels = __importStar(require("../codec/cosmos-models"));
const constant_1 = require("../constant");
const address_1 = require("./address");
const msgUpdateClientInnerFields = [
    "lastCommitHash",
    "dataHash",
    "validatorsHash",
    "nextValidatorsHash",
    "consensusHash",
    "appHash",
    "lastResultsHash",
    "evidenceHash",
    "hash",
    "signature",
    "proposerAddress",
    "validatorAddress",
    "address",
    "ed25519",
    "data",
];
const msgRecvPacketInnerFields = ["proofCommitment", "data"];
const decodeHexList = [...msgUpdateClientInnerFields, ...msgRecvPacketInnerFields];
const decodeNestedMsg = (obj) => {
    for (const key in obj) {
        const value = obj[key];
        if (decodeHexList.includes(key) && value instanceof Uint8Array) {
            obj[key] = Buffer.from(value).toString("hex");
        }
        else if (typeof value === "object" &&
            (value === null || value === void 0 ? void 0 : value.typeUrl) !== undefined &&
            (value === null || value === void 0 ? void 0 : value.value) !== undefined &&
            Object.values(codec_1.TxTypes).includes(value === null || value === void 0 ? void 0 : value.typeUrl)) {
            obj[key].value = codec_1.registry.decode(value);
            obj[key] = decodeNestedMsg(value);
        }
        else if (value instanceof Object) {
            obj[key] = decodeNestedMsg(value);
        }
    }
    return obj;
};
const decode = (bytes) => {
    if (!bytes)
        return bytes;
    const decodedTx = CosmosModels.Tx.Tx.decode(bytes);
    const carbonTx = Object.assign(Object.assign({}, decodedTx), { body: undefined });
    if (decodedTx.body) {
        carbonTx.body = Object.assign(Object.assign({}, decodedTx.body), { messages: [] });
        for (const message of decodedTx.body.messages) {
            try {
                carbonTx.body.messages.push({
                    typeUrl: message.typeUrl,
                    value: decodeNestedMsg(codec_1.registry.decode(message)),
                });
            }
            catch (error) {
                console.error(`failed to decode tx message: ${message === null || message === void 0 ? void 0 : message.typeUrl}`);
                console.error(error);
                carbonTx.body.messages.push(message);
            }
        }
    }
    else {
        delete carbonTx.body;
    }
    return carbonTx;
};
exports.decode = decode;
const getSender = (decodedTx, opts) => {
    var _a, _b, _c;
    const publicKey = (_c = (_b = (_a = decodedTx.authInfo) === null || _a === void 0 ? void 0 : _a.signerInfos) === null || _b === void 0 ? void 0 : _b[0].publicKey) === null || _c === void 0 ? void 0 : _c.value;
    if (!publicKey) {
        throw new Error(`could not get signer public key`);
    }
    const keyBuffer = Buffer.from(publicKey).slice(2);
    return address_1.SWTHAddress.publicKeyToAddress(keyBuffer, opts);
};
exports.getSender = getSender;
var BroadcastTxMode;
(function (BroadcastTxMode) {
    BroadcastTxMode["BroadcastTxSync"] = "sync";
    BroadcastTxMode["BroadcastTxAsync"] = "async";
    BroadcastTxMode["BroadcastTxBlock"] = "block";
})(BroadcastTxMode = exports.BroadcastTxMode || (exports.BroadcastTxMode = {}));
var ErrorType;
(function (ErrorType) {
    ErrorType["SIGNATURE_REJECTION"] = "signature_rejection";
    ErrorType["BROADCAST_FAIL"] = "broadcast_fail";
    ErrorType["BLOCK_FAIL"] = "block_fail";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
class CarbonCustomError extends Error {
    constructor(msg, type, data) {
        super(msg);
        this.type = type;
        this.data = data;
    }
}
exports.CarbonCustomError = CarbonCustomError;
exports.Types = codec_1.TxTypes;
exports.DEFAULT_SIGN_OPTS = {
    fee: constant_1.DEFAULT_FEE,
    memo: "",
};
exports.TxGasCostTypeDefaultKey = "default_fee";
exports.TxMinGasPriceTypeDefaultKey = "swth";
exports.TxGasCostTypeMap = {
    [codec_1.TxTypes.MsgClaimPoolRewards]: "claim_pool_rewards",
    [codec_1.TxTypes.MsgCreateVote]: "create_oracle_vote",
    [codec_1.TxTypes.MsgCreateOrder]: "create_order",
    [codec_1.TxTypes.MsgCreatePool]: "create_pool",
    [codec_1.TxTypes.MsgCreatePoolWithLiquidity]: "create_pool",
    [codec_1.TxTypes.MsgStakePoolToken]: "stake_pool_token",
    [codec_1.TxTypes.MsgUnstakePoolToken]: "unstake_pool_token",
};
const LibPackages = ['ibc', 'cosmos', 'alliance'];
const BacklistedMessages = [];
// to use signDirect for metamask signing if messages are from libraries (cosmos-sdk, ibc, alliance).
// Reasons:
// 1. There is decoding issue with MsgGrantAllowance in amino
// 2. For Ibc MsgTransfer, there is an overflow issue with timeouttimestamp overflow (from uint32) during unmarshalJSON, even though it is defined as uint64 
// (This can be resolved from the client side by use sendIBCTransfer instead of sendIBCTransferV2) but using signDirect here fixes it too.
// 3. Ethermint is still using legacyMsg.getSigners() to verify many amino signed eip712 txs. However, getSigners() is deprecated and not implmented in messages from cosmos-sdk anymore.
// 4. as of comsos-sdk v0.50 --> very few messages are using legacyDec so we can safely use signDirect
const useSignDirectForMetamask = (messages) => {
    const typeUrls = messages.map(m => m.typeUrl);
    return !!Object.values(codec_1.TxTypes).find(typeUrl => exports.isLibMsg(typeUrl) && typeUrls.includes(typeUrl));
};
exports.useSignDirectForMetamask = useSignDirectForMetamask;
const isLibMsg = (typeUrl) => {
    // /ibc.core.client.v1.UpgradeProposal --> ibc
    const pkg = typeUrl.split('.')[0].substring(1);
    return LibPackages.includes(pkg) && !BacklistedMessages.includes(typeUrl);
};
exports.isLibMsg = isLibMsg;
